import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Menu {
	path?: string;
	title?: string;
	type?: string;
	megaMenu?: boolean;
	image?: string;
	active?: boolean;
	badge?: boolean;
	badgeText?: string;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	constructor() { }

	public screenWidth: any;
	public leftMenuToggle: boolean = false;
	public mainMenuToggle: boolean = false;

	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		{
			path: '/',
			title: 'INICIO',
			type: 'link'
		},
		{
			title: 'Productos',
			type: 'sub',
			active: false,
			children: [
				{ path: '/shop/collection/left/sidebar', title: 'Equipos Móviles', type: 'link' }
			]
		},
		/* Tercer ítem del menú (products / PRODUCTOS) — oculto hasta definir estructura final */
		/* {
			title: 'products',
			type: 'sub',
			active: false,
			children: [
				{
					title: 'sidebar',
					type: 'sub',
					active: false,
					children: [
						{ path: '/shop/product/left/sidebar/trim-dress', title: 'left-sidebar', type: 'link' }
					]
				}
			]
		}, */
		/* {
			title: 'Features',
			type: 'sub',
			megaMenu: true,
			badge: true,
			badgeText: 'new',
			active: false,
			children: [
				{
					title: 'portfolio',
					type: 'sub',
					active: false,
					children: [
						{ path: '/pages/portfolio/grid/two', title: 'portfolio-grid-2', type: 'link' },
						{ path: '/pages/portfolio/grid/three', title: 'portfolio-grid-3', type: 'link' },
						{ path: '/pages/portfolio/grid/four', title: 'portfolio-grid-4', type: 'link' },
						{ path: '/pages/portfolio/masonry/grid/two', title: 'masonry-grid-2', type: 'link' },
						{ path: '/pages/portfolio/masonry/grid/three', title: 'masonry-grid-3', type: 'link' },
						{ path: '/pages/portfolio/masonry/grid/four', title: 'masonry-grid-4', type: 'link' },
						{ path: '/pages/portfolio/masonry/full-width', title: 'masonry-Full-Width', type: 'link' }
					]
				},
				{
					title: 'add-to-cart',
					type: 'sub',
					active: false,
					children: [
						{ path: '/', title: 'cart-left', type: 'link' }
					]
				},
				{
					title: 'email-template',
					type: 'sub',
					active: false,
					children: [
						{ path: 'http://themes.pixelstrap.com/multikart/front-end/email-order-success.html', title: 'order-success', type: 'extTabLink' },
						{ path: 'http://themes.pixelstrap.com/multikart/front-end/email-order-success-two.html', title: 'order-success-2', type: 'extTabLink' },
						{ path: 'http://themes.pixelstrap.com/multikart/front-end/email-template.html', title: 'email-template', type: 'extTabLink' },
						{ path: 'http://themes.pixelstrap.com/multikart/front-end/email-template-two.html', title: 'email-template-2', type: 'extTabLink' }
					]
				}
			]
		}, */
		/* Menú PAGES: oculto temporalmente; reactivar cuando se use de nuevo */
		/* {
			title: 'pages',
			type: 'sub',
			active: false,
			children: [
				{
					title: 'account',
					type: 'sub',
					active: false,
					children: [
						{ path: '/pages/wishlist', title: 'wishlist', type: 'link' },
						{ path: '/pages/cart', title: 'cart', type: 'link' },
						{ path: '/pages/dashboard', title: 'dashboard', type: 'link' },
						{ path: '/pages/login', title: 'login', type: 'link' },
						{ path: '/pages/register', title: 'register', type: 'link' },
						{ path: '/pages/contact', title: 'contact', type: 'link' },
						{ path: '/pages/forget/password', title: 'forget-password', type: 'link' },
						{ path: '/pages/profile', title: 'profile', type: 'link' },
						{ path: '/pages/checkout', title: 'checkout', type: 'link' },
					]
				},
				{ path: '/pages/aboutus', title: 'about-us', type: 'link' },
				{ path: '/pages/search', title: 'search', type: 'link' },
				{ path: '/pages/order/success', title: 'order-success', type: 'link' },
				{ path: '/shop/compare', title: 'compare', type: 'link' },
				{ path: '/pages/collection', title: 'collection', type: 'link' },
				{ path: '/pages/lookbook', title: 'lookbook', type: 'link' },
				{ path: '/pages/404', title: '404', type: 'link' }
			]
		} */
	];

	LEFTMENUITEMS: Menu[] = [
		{
			title: 'watch models',
			type: 'sub',
			megaMenu: true,
			active: false,
			children: [
				{
					title: 'collections',
					type: 'link',
					active: false,
					children: [
						{ path: '/shop/collection/left/sidebar', title: 'all watches', type: 'link' },
						{ path: '/', title: 'featured', type: 'link' },
						{ path: '/shop/product/left/sidebar/trim-dress', title: 'trim dress', type: 'link' }
					]
				}
			]
		},
		{
			title: 'shop',
			type: 'sub',
			active: false,
			children: [
				{ path: '/shop/collection/left/sidebar', title: 'catalog', type: 'link' },
				{ path: '/pages/cart', title: 'cart', type: 'link' }
			]
		},
		{
			path: '/',
			title: 'home',
			type: 'link'
		}
	];

	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
	leftMenuItems = new BehaviorSubject<Menu[]>(this.LEFTMENUITEMS);

}
